/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_What_LeadInputs */

const en_fc_home_what_lead = /** @type {(inputs: Fc_Home_What_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The FilmCraft video editor is a free, open-source non-linear editor built by the ArtCraft team. It is written in Rust, runs natively on macOS, Windows and Linux, and also compiles to WebAssembly so it can run inside a browser tab.`)
};

/**
* | output |
* | --- |
* | "The FilmCraft video editor is a free, open-source non-linear editor built by the ArtCraft team. It is written in Rust, runs natively on macOS, Windows and Li..." |
*
* @param {Fc_Home_What_LeadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_what_lead = /** @type {((inputs?: Fc_Home_What_LeadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_What_LeadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_what_lead(inputs)
});
export { fc_home_what_lead as "fc.home.what.lead" }